export default __webpack_public_path__ + "static/media/scan.51edca67.svg";